import { styled } from '@mui/material/styles';
import { Box, Button, Paper, alpha } from '@mui/material';

export const PageWrapper = styled(Box)(({ theme }) => ({
  padding: theme.spacing(3),
  backgroundColor: '#F8F9FA',
  minHeight: '100vh',
}));

export const HeaderCard = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(3),
  borderRadius: '12px',
  display: 'flex',
  alignItems: 'center',
  marginBottom: theme.spacing(3),
  boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.05)',
}));

export const IconWrapper = styled(Box)(({ theme }) => ({
  width: '64px',
  height: '64px',
  borderRadius: '12px',
  backgroundColor: '#F0F0F0',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  marginRight: theme.spacing(3),
}));

export const HeaderInfo = styled(Box)({
  flex: 1,
});

export const StatusBadge = styled(Box)<{ status: string }>(({ status }) => {
  const statusLower = status?.toLowerCase();
  let bgColor = '#F3F4F6';
  let textColor = '#1F2937';

  if (statusLower === 'pending') {
    bgColor = '#FEF3C7';
    textColor = '#92400E';
  } else if (statusLower === 'approved') {
    bgColor = '#DCFCE7';
    textColor = '#166534';
  } else if (statusLower === 'rejected') {
    bgColor = '#FEE2E2';
    textColor = '#991B1B';
  } else if (statusLower === 'suspended') {
    bgColor = '#FFEDD5';
    textColor = '#C2410C';
  }

  return {
    padding: '4px 12px',
    borderRadius: '4px',
    fontSize: '12px',
    fontWeight: 600,
    display: 'inline-block',
    marginLeft: '12px',
    backgroundColor: bgColor,
    color: textColor,
    textTransform: 'capitalize'
  };
});

export const SectionCard = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(3),
  borderRadius: '12px',
  marginBottom: theme.spacing(3),
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.05)',
  border: '1px solid #F0F0F0',
}));

export const SectionInfo = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
});

export const ReviewLink = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  color: '#666',
  cursor: 'pointer',
  padding: '8px 16px',
  borderRadius: '8px',
  transition: 'all 0.2s',
  '&:hover': {
    color: '#2563eb',
    backgroundColor: '#F0F7FF',
  },
}));

export const HeaderActions = styled(Box)({
  display: 'flex',
  gap: '12px',
});

export const SuspendButton = styled(Button)({
  textTransform: 'none',
  borderColor: '#FF4D4F',
  color: '#FF4D4F',
  padding: '6px 24px',
  borderRadius: '8px',
  fontWeight: 500,
  fontSize: '13px',
  '&:hover': {
    borderColor: '#D4380D',
    backgroundColor: alpha('#FF4D4F', 0.05),
  },
  '&.Mui-disabled': {
    borderColor: '#F0F0F0',
    color: '#CCC',
  }
});

export const ReactivateButton = styled(Button)({
  textTransform: 'none',
  backgroundColor: '#5E8E7E',
  color: '#FFFFFF',
  padding: '6px 24px',
  borderRadius: '8px',
  fontWeight: 500,
  fontSize: '13px',
  '&:hover': {
    backgroundColor: '#4A7A6A',
  },
  '&.Mui-disabled': {
    backgroundColor: '#F0F0F0',
    color: '#CCC',
  }
});

export const VerificationActionCard = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(3),
  borderRadius: '12px',
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.05)',
  border: '1px solid #F0F0F0',
}));

export const ActionButtons = styled(Box)(({ theme }) => ({
  display: 'flex',
  gap: theme.spacing(2),
}));

export const RejectButton = styled(Button)({
  textTransform: 'none',
  borderColor: '#E0E0E0',
  color: '#666',
  padding: '8px 40px',
  borderRadius: '8px',
  fontWeight: 500,
  fontSize: '14px',
  '&:hover': {
    borderColor: '#333',
    backgroundColor: 'transparent',
    color: '#333',
  },
  '&.Mui-disabled': {
    borderColor: '#F0F0F0',
    color: '#CCC',
  }
});

export const ApproveButton = styled(Button)({
  textTransform: 'none',
  backgroundColor: '#5E8E7E',
  color: '#FFFFFF',
  padding: '8px 40px',
  borderRadius: '8px',
  fontWeight: 500,
  fontSize: '14px',
  '&:hover': {
    backgroundColor: '#4A7A6A',
  },
  '&.Mui-disabled': {
    backgroundColor: '#F0F0F0',
    color: '#CCC',
  },
});
